export class PelletizingProductionResult {
    constructor({
          id= null, 
          planCode= ``, 
          locName= ``,
          day= ``,                    
          shift='',
          shiftStartTime='',
          shiftEndTime='',         
          productionName= ``,
          planQuantity= ``,
          realQuantity= ``,
          completeRate= ``
          
      } = {}) {
      this.id = id;
      this.planCode = planCode;
      this.locName = locName; 
      this.day = day;
      this.shift = shift;
      this.shiftStartTime = shiftStartTime,
      this.shiftEndTime = shiftEndTime,  
      this.productionName = productionName;
      this.planQuantity = planQuantity;
      this.realQuantity = realQuantity;
      this.completeRate = completeRate;
    }
  }
  export function gridFields() {
    return Object.freeze([        
        {
          key: 'planCode',
          label: 'lbl.basic.planCode',
          sortable: true,
          form: {
            type: 'input'
          }
        }, 
        {
          key: 'locName',
          label: 'lbl.basic.locName',
          sortable: true,
          form: {
            type: 'input'
          }
        }, 
        {
          key: 'day',
          label: 'lbl.basic.day',
          sortable: true,
          form: {
            type: 'datepicker'
          }
        },               
        {
          key: 'shift',
          label: 'lbl.basic.shift',
          sortable: true,
          form: {
            type: 'input'
          }
        }, 
        {
          key: 'shiftStartTime',
          label: 'lbl.basic.startTime',
          sortable: false,
          form: {
            type: 'displayTime'
          }
        },
        {
          key: 'shiftEndTime',
          label: 'lbl.basic.endTime',
          sortable: false,
          form: {
            type: 'displayTime'
          }
        },                
        {
          key: 'productionName',
          label: 'lbl.prd.execution.productionName',
          sortable: false,
          form: {
            type: 'input'
          }
        }, 
        {
          key: 'planQuantity',
          label: 'lbl.prd.execution.planQuantity',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'realQuantity',
          label: 'lbl.prd.execution.actualQuantity',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'completeRate',
          label: 'lbl.prd.execution.completeRate',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'operate',
          label: 'lbl.basic.update',
          form: {
              type: 'formatter'
          }
        }
    ]);
  }
  export const fields = Object.freeze(Object.keys(new PelletizingProductionResult()).map(i => 'entity.' + i));
  export const filterFields = [
    'filter.planCodeFilter',
    'filter.plantFilter',
    'filter.shiftFilter',
    'filter.startDayFilter',
    'filter.endDayFilter',    
  ];
  export const filter = {
    'planCodeFilter': "",    
    'startDayFilter': "",
    'endDayFilter': "",
    'plantFilter': "",
    'shiftFilter': "",
  };